<nav class="navbar navbar-light colorFondo navbar-nav w-100 h-30" style="height: 30px; padding-right: 8%; padding-top: 0px; font-size: medium;">
  <mat-form-field appearance="none" class="ml-auto" style="height: 30px; padding: 0px 0px 0px 0px;">
    <mat-select  [value]="idiomaSelected" (selectionChange)="useLanguage($event.value)" class="header-select">
      <mat-option *ngFor="let idioma of idiomas" [value]="idioma.value">
        {{idioma.idioma}}
      </mat-option>
    </mat-select>
  </mat-form-field>
</nav>
